// extracted by mini-css-extract-plugin
export default {"body":"ImageContainer_body__lCCu-"};